import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/core/config.service";
import { FinOpsAwsDetailsData, FinOpsAwsResourcesDayMeasures } from "./finops-aws-resources.model";

@Injectable({
    providedIn: 'root'
})
export class FinOpsAwsResourcesService {

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService
    ) {
    }

    loadFinOpsAwsResourcesHistoricalData(date: string, granularity: string, account: string) {
        return this.httpClient.get<FinOpsAwsResourcesDayMeasures>(`${this.configService.config.apiUrl}/finops/aws/resources?date=${date}&granularity=${granularity}&account=${account}`)
    }

    loadFinOpsAwsResourcesMeasures(date: string, accountId: string) {
        return this.httpClient.get<FinOpsAwsResourcesDayMeasures>(`${this.configService.config.apiUrl}/finops/aws/resources/measures?date=${date}&account=${accountId}`)
    }

    loadFinOpsAwsResourceDetails(date: string, accountId: string, resourceId: string) {
        return this.httpClient.get<FinOpsAwsDetailsData>(`${this.configService.config.apiUrl}/finops/aws/resources/details?date=${date}&account=${accountId}&resource_id=${resourceId}`)
    }
}
